module.exports = __webpack_public_path__ + "static/media/gruenLogo.4c7c0a57.webp";